export const PreforeclosureStatusConstant = [
     {id: "select_all", name: "Select All"},
    {id: "ns", name: "Notice of Sale"},
    {id: "nd", name: "Notice of Default"},
    {id: "lp", name: "Notice of Lis Pendens"},
    {id: "nf", name: "Notice of Foreclosure"},
    {id: "nt", name: "Notice of Trustee Sale"},
    {id: "rl", name: "Release"},
]